<div class="grid grid-nogutter align-items-center m-0 header">
    <div class="col-6">
      <h1>{{title}}</h1>
    </div>
    <div class="col-6 flex justify-content-end">
        <ng-content>
            
        </ng-content>
    </div>
</div>